// extracted by mini-css-extract-plugin
export default {"main":"palavrab_main__y4gOX","text":"palavrab_text__Y6nmu","button":"palavrab_button__5W0cT","header":"palavrab_header__dfThz"};